// extracted by mini-css-extract-plugin
export var phone = "_2g-0";
export var phoneDragging = "_2g-1";